<template>
  <div class="w-screen h-screen flex flex-col items-center justify-center overflow-hidden" style="background-color: #020308">
    <div class="flex flex-col items-center w-full pb-10 px-3" style="max-width: 400px;">
      <!-- Logo -->
      <img src="../../assets/images/foreplay-logo.png" style="width: 136px; height: 40px;" />
      <div v-if="isActivationFlowReauth" class="w-full flex items-center px-2 py-2.5 rounded-lg bg-neutral-alpha-200 mt-12">
        <InfoIcon class="text-neutral-alpha-650 flex-shrink-0" :width="28" :height="28" />
        <BaseText type="body" size="sm" class="text-neutral-alpha-650 ml-2">
          Please re-enter your credentials to continue with your account activation.
        </BaseText>
      </div>
      <form class="w-full" :class="isActivationFlowReauth ? 'mt-6' : 'mt-12'" @submit.prevent="sendEmailLink">
        <!-- Email Input -->
        <BaseText type="label" size="md" class="text-white w-full mb-1">
          Email
        </BaseText>
        <div class="input-container w-full flex items-center" :class="{'active': email?.length || emailInputFocused, 'errored': emailError}">
          <input v-model="email" class="form-input flex-grow min-w-0" placeholder="Enter your email address" type="email"
          @focus="emailInputFocused = true" @blur="emailInputFocused = false" @input="() => emailError = false" />
          <transition>
            <InfoIcon v-if="emailError" style="color: #DF1C41" />
          </transition>
        </div>
        <transition name="error">
          <div v-if="emailError" class="w-full flex items-end h-7">
            <BaseText type="body" size="sm" style="color: #DF1C41">
              Please enter a valid email address
            </BaseText>
          </div>
        </transition>
        <!-- Password Input -->
        <BaseText type="label" size="md" class="text-white w-full mt-4 mb-1">
          Password
        </BaseText>
        <div class="input-container w-full flex items-center" :class="{'active': password?.length || passwordInputFocused, 'errored': passwordError}">
          <input v-model="password" class="form-input flex-grow min-w-0" placeholder="Enter your password" :type="showPassword ? 'text' : 'password'" 
          @focus="passwordInputFocused = true" @blur="passwordInputFocused = false" @input="() => passwordError = false" />
          <button class="w-6 h-6 relative flex items-center cursor-pointer flex-shrink-0" style="color: rgba(255, 255, 255, 0.44)" 
          type="button" @click="showPassword= !showPassword">
            <transition name="visibility">
              <InfoIcon v-if="passwordError" class="ml-auto" style="color: #DF1C41" />
              <svg v-else-if="showPassword" xmlns="http://www.w3.org/2000/svg" key="visible-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" class="h-4">
                <path d="M9.16536 4.42071C8.76872 4.5401 8.54397 4.95841 8.66335 5.35505C8.78273 5.75169 9.20105 5.97645 9.59768 5.85706L9.16536 4.42071ZM21.529 11.1176L22.1806 10.7462V10.7462L21.529 11.1176ZM19.1413 14.9666C18.8678 15.2776 18.8982 15.7515 19.2092 16.0251C19.5203 16.2986 19.9942 16.2682 20.2677 15.9571L19.1413 14.9666ZM21.5297 12.8811L20.8781 12.5098L20.8781 12.5098L21.5297 12.8811ZM3.28029 2.21967C2.9874 1.92678 2.51253 1.92678 2.21963 2.21967C1.92674 2.51256 1.92674 2.98744 2.21963 3.28033L3.28029 2.21967ZM2.47016 11.1188L3.12179 11.4901H3.12179L2.47016 11.1188ZM20.7196 21.7803C21.0125 22.0732 21.4874 22.0732 21.7803 21.7803C22.0732 21.4874 22.0732 21.0126 21.7803 20.7197L20.7196 21.7803ZM2.47125 12.8829L1.81966 13.2543H1.81966L2.47125 12.8829ZM10.2322 10.2322C10.5251 9.93934 10.5251 9.46447 10.2322 9.17157C9.9393 8.87868 9.46443 8.87868 9.17153 9.17157L10.2322 10.2322ZM14.8284 14.8284C15.1213 14.5355 15.1213 14.0607 14.8284 13.7678C14.5355 13.4749 14.0606 13.4749 13.7677 13.7678L14.8284 14.8284ZM9.59768 5.85706C13.5394 4.67067 17.9939 6.42962 20.8774 11.489L22.1806 10.7462C19.0295 5.21732 13.9174 2.99041 9.16536 4.42071L9.59768 5.85706ZM20.2677 15.9571C20.9622 15.1674 21.6043 14.2652 22.1814 13.2524L20.8781 12.5098C20.3482 13.4398 19.7644 14.258 19.1413 14.9666L20.2677 15.9571ZM20.8774 11.489C21.0579 11.8057 21.058 12.1942 20.8781 12.5098L22.1814 13.2524C22.6242 12.4754 22.6229 11.5222 22.1806 10.7462L20.8774 11.489ZM2.21963 3.28033L5.99934 7.06003L7.06 5.99937L3.28029 2.21967L2.21963 3.28033ZM3.12179 11.4901C4.21375 9.57383 5.53387 8.13258 6.95695 7.14609L6.10238 5.91332C4.47301 7.04281 3.00749 8.66097 1.81853 10.7475L3.12179 11.4901ZM5.99934 7.06003L16.9399 18.0006L18.0005 16.9399L7.06 5.99937L5.99934 7.06003ZM16.9399 18.0006L20.7196 21.7803L21.7803 20.7197L18.0005 16.9399L16.9399 18.0006ZM1.81966 13.2543C3.74764 16.6368 6.40542 18.7894 9.29529 19.6173C12.1917 20.4471 15.2481 19.9232 17.8975 18.0866L17.0429 16.8539C14.7434 18.4479 12.1496 18.8747 9.7084 18.1753C7.26065 17.4741 4.8934 15.6178 3.12283 12.5115L1.81966 13.2543ZM1.81853 10.7475C1.37557 11.5249 1.37752 12.4786 1.81966 13.2543L3.12283 12.5115C2.94218 12.1946 2.9421 11.8055 3.12179 11.4901L1.81853 10.7475ZM12 14.5C10.6192 14.5 9.49996 13.3807 9.49996 12H7.99996C7.99996 14.2091 9.79082 16 12 16V14.5ZM9.49996 12C9.49996 11.3094 9.77896 10.6855 10.2322 10.2322L9.17153 9.17157C8.4485 9.89461 7.99996 10.8956 7.99996 12H9.49996ZM13.7677 13.7678C13.3145 14.221 12.6905 14.5 12 14.5V16C13.1043 16 14.1054 15.5515 14.8284 14.8284L13.7677 13.7678Z"
                fill="currentColor" />
              </svg>
              <svg v-else-if="password?.length" xmlns="http://www.w3.org/2000/svg" key="hide-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" class="h-4">
                <path d="M2.47032 11.1187L1.81869 10.7474H1.81869L2.47032 11.1187ZM21.5298 11.1188L22.1814 10.7475V10.7475L21.5298 11.1188ZM2.47032 12.8811L1.81869 13.2524H1.81869L2.47032 12.8811ZM21.5298 12.8812L22.1814 13.2526V13.2526L21.5298 12.8812ZM3.12194 11.49C5.43733 7.42677 8.76885 5.49998 12 5.5C15.2312 5.50002 18.5627 7.42687 20.8781 11.4901L22.1814 10.7475C19.6579 6.31907 15.8791 4.00003 12 4C8.12093 3.99997 4.34216 6.31896 1.81869 10.7474L3.12194 11.49ZM1.81869 13.2524C4.34216 17.6809 8.12092 19.9999 12 19.9999C15.8791 20 19.6579 17.681 22.1814 13.2526L20.8781 12.5099C18.5627 16.5732 15.2312 18.5 12 18.4999C8.76886 18.4999 5.43733 16.5731 3.12194 12.5098L1.81869 13.2524ZM1.81869 10.7474C1.37619 11.5239 1.37619 12.4759 1.81869 13.2524L3.12194 12.5098C2.94177 12.1936 2.94177 11.8062 3.12194 11.49L1.81869 10.7474ZM20.8781 11.4901C21.0583 11.8063 21.0583 12.1937 20.8781 12.5099L22.1814 13.2526C22.6239 12.476 22.6239 11.524 22.1814 10.7475L20.8781 11.4901ZM14.5 12C14.5 13.3807 13.3807 14.5 12 14.5V16C14.2092 16 16 14.2091 16 12H14.5ZM12 14.5C10.6193 14.5 9.50004 13.3807 9.50004 12H8.00004C8.00004 14.2091 9.7909 16 12 16V14.5ZM9.50004 12C9.50004 10.6193 10.6193 9.5 12 9.5V8C9.7909 8 8.00004 9.79086 8.00004 12H9.50004ZM12 9.5C13.3807 9.5 14.5 10.6193 14.5 12H16C16 9.79086 14.2092 8 12 8V9.5Z"
                fill="currentColor" />
              </svg>
            </transition>
          </button>
        </div>
        <transition name="error">
          <div v-if="passwordError" class="w-full flex items-end h-7">
            <BaseText type="body" size="sm" style="color: #DF1C41">
              Please enter a valid password
            </BaseText>
          </div>
        </transition>
        <!-- Sign In Button -->
        <button class="submit-button w-full mt-6 p-2 h-10 bg-white flex items-center justify-center transition duration-200"
        :class="loadingEmailLink ? 'cursor-default' : 'hover:bg-opacity-90'"
        type="submit" :disabled="loadingEmailLink" :loading="loadingEmailLink">
          <BaseLoadingSpinnerCircle v-if="loadingEmailLink" :duration="1" />
          <BaseText v-else type="heading" size="sm">
            Sign In
          </BaseText>
        </button>
      </form>
      <!-- Alternative Route Links -->
      <div v-if="!isActivationFlowReauth" class="w-full flex flex-col gap-y-3 xs:flex-row items-center mt-4 xs:mt-6">
        <div class="flex items-center gap-1.5">
          <BaseText type="body" size="sm" class="text-neutral-alpha-650">
            Don't have an account?
          </BaseText>
          <router-link to="/sign-up" class="text-neutral-alpha-700 transition-colors duration-100 hover:text-white">
            <BaseText type="label" size="sm">
              Sign up
            </BaseText>
          </router-link>
        </div>
        <router-link to="/forgot-password" class="xs:ml-auto text-neutral-alpha-700 transition-colors duration-100 hover:text-white">
          <BaseText type="label" size="sm">
            Forgot Password?
          </BaseText>
        </router-link>
      </div>
      <!-- Divider -->
      <div v-if="!isActivationFlowReauth" class="w-full flex items-center gap-6 py-1 mt-3 xs:mt-6">
        <div class="flex-grow h-0 border-t border-neutral-alpha-50" />
        <BaseText type="body" size="sm" class="text-neutral-alpha-650">
          or
        </BaseText>
        <div class="flex-grow h-0 border-t border-neutral-alpha-50" />
      </div>
      <!-- Google Sign In Button -->
      <button v-if="!isActivationFlowReauth" class="google-btn w-full flex items-center justify-center gap-2.5 p-2 mt-4"
      @click="signInWithGoogle">
        <img src="../../assets/images/google-logo.png" class="w-5 h-5" style="opacity: 0.68">
        <BaseText type="heading" size="sm" class="text-white">
          Sign in with Google
        </BaseText>
      </button>
      <!-- Disclaimer -->
      <BaseText type="body" size="sm" class="w-full text-center text-neutral-alpha-650 mt-6" style="max-width: 360px">
        By signing in to the Foreplay app, you agree to our <a
          href="https://www.foreplay.co/page/terms-of-service"
          target="_blank"
          class="font-semibold text-neutral-alpha-700 transition-colors duration-200 hover:text-white"
        > Terms and Conditions </a> and <a
          href="https://www.foreplay.co/page/privacy-policy"
          target="_blank"
          class="font-semibold text-neutral-alpha-700 transition-colors duration-200 hover:text-white"
        > Privacy Policy</a>
      </BaseText>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { captureException } from '@sentry/vue'
import { getGoogleAuthErrorMessage } from '@/utils/auth/getGoogleAuthErrorMessage'
import Logo from '../../components/globals/Logo.vue'
import store from '../../store'
import InfoIcon from '../../components/globals/Icons/InfoSimpleIcon.vue'

export default {
  name: 'LoginView',
  components: { 
    Logo,
    InfoIcon 
  },
  data () {
    return {
      email: '',
      password: '',
      loadingEmailLink: false,
      passwordError: false,
      showPassword: false,
      emailError: false,
      timeoutId: null,

      emailInputFocused: false,
      passwordInputFocused: false
    }
  },
  async mounted () {
    clearTimeout(this.timeoutId)
    // get utm_source, utm_medium, utm_campaign from store
    const utmSource = store.getters['MiscModule/getUtmSource']
    const utmMedium = store.getters['MiscModule/getUtmMedium']
    const utmCampaign = store.getters['MiscModule/getUtmSource']

    this.timeoutId = setTimeout(() => {
      window.analytics.page('Login Page Viewed', {
        pathname: window.location.pathname,
        path: window.location.pathname,
        referrer: window.location.href,
        utmCampaign: utmCampaign || '',
        utmSource: utmSource || '',
        utmMedium: utmMedium || ''
      })
    }, 5000)
  },
  computed: {
    isActivationFlowReauth () {
      // This would be in the case where we have to reauth for the user to complete the account activation flow
      return this.$route?.query?.authOob
    }
  },
  methods: {
    ...mapActions('AuthModule', [
      'loginUserWithGoogle',
      'loginUserWithEmailAndPassword'
    ]),
    async signInWithGoogle () {
      try {
        await this.loginUserWithGoogle()
      } catch (e) {
        const message = getGoogleAuthErrorMessage(e)
        if (!message) return
        captureException(e)
        this.$showAlert({ message, type: 'error' })
      }
    },
    // Send Email Link
    async sendEmailLink () {
      if (!this.email?.length) this.emailError = true
      if (!this.password?.length) this.passwordError = true
      if (this.emailError || this.passwordError) return

      this.loadingEmailLink = true

      try {
        await this.loginUserWithEmailAndPassword({
          email: this.email,
          password: this.password
        })
      } catch (e) {
        console.log(e)
        this.$showAlert({
          message: e.message,
          type: 'error'
        })
      } finally {
        this.loadingEmailLink = false
      }
    }
  },
  metaInfo: {
    title: 'Log In Your Foreplay Account | Foreplay.co'
  }
}
</script>

<style scoped>
.submit-button {
  color: #13151A;
  border-radius: 10px;
}

.google-btn {
  border: 1px solid;
  border-color: rgba(255, 255, 255, 0.16);
  background-color: transparent;
  border-radius: 10px;
  transition: border-color 150ms ease-in-out, background-color 150ms ease-in-out;
}
.google-btn:hover {
  border-color: transparent;
  background-color: rgba(255, 255, 255, 0.08);
}

.input-container {
  background-color: rgba(255, 255, 255, 0.10);
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.10);
  border-radius: 10px;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  transition: background-color 150ms ease-in-out, box-shadow 150ms ease-in-out;
}
.input-container:hover {
  background-color: rgba(255, 255, 255, 0.16);
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.16);
}
.input-container.active, .input-container.active:hover {
  background-color: transparent;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.10);
}
.input-container.errored, .input-container.active.errored, .input-container.active.errored:hover {
  background-color: transparent;
  box-shadow: 0 0 0 1px #F4003A;
}

.form-input {
  background-color: transparent;
  color: white;
  caret-color: white;
  max-width: none;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;

  /* Reset default styles */
  -webkit-appearance: none;  /* Remove default styling in WebKit browsers */
  -moz-appearance: none;     /* Remove default styling in Firefox */
  appearance: none;          /* Remove default styling in modern browsers */
  padding: 0;
  margin: 0;
  border: none;
  font-size: inherit;
  outline: none;

  /* This is because browsers want to force their ugly styling on you when autofill is triggered. */
  /* This is the only way to prevent that, since they use !important in their overrides. */
  transition:
    color 99999999s step-end,
    background-color 99999999s step-end;
}
.form-input:focus {
  outline: none;
  border: none;
  box-shadow: none;
}
.form-input::placeholder {
  transition: color 200ms ease-in-out;
  color: rgba(255, 255, 255, 0.44);
}
.form-input:focus::placeholder {
  color: rgba(255, 255, 255, 0.2);
}

/* Override browser autofill styles */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-text-fill-color: white !important;
}

/* Firefox autocomplete */
.form-input:-moz-autofill {
  color: white !important;
}

/* General autocomplete prevention */
.form-input:autofill {
  color: white !important;
}

.visibility-enter-active, .visibility-leave-active {
  transition: opacity 75ms ease-in-out;
  position: absolute;
  right: 0px;
  top: 4px;
}
.visibility-enter-from, .visiblity-enter, .visibility-leave-to {
  opacity: 0;
}
.visibility-enter-to, .visibility-leave-from {
  opacity: 1;
}
.v-enter-active, .v-leave-active {
  transition: opacity 75ms ease-in-out;
}
.v-enter-from, .v-enter, .v-leave-to {
  opacity: 0;
}
.v-enter-to, .v-leave-from {
  opacity: 1;
}
.error-enter-active {
  animation: errorEnter 75ms ease-in-out forwards;
}
.error-leave-active {
  animation: errorLeave 75ms ease-in-out forwards;
}
@keyframes errorEnter {
  0% { height: 0px; opacity: 0; }
  50% { opacity: 0; }
  100% { height: 28px; opacity: 1; }
}
@keyframes errorLeave {
  0% { height: 28px; opacity: 1; }
  50% { opacity: 0; }
  100% { height: 0px; opacity: 0; }
}
</style>